import { generatePath } from 'react-router-dom'
import { CompanyTag } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { ClientDtoKey } from 'api/Clients/Types/Client'
import { NameDto } from 'api/Common/Types'
import { Link } from 'components/Link'
import { formatLocalDateUTC } from 'utils/date'
import { links } from 'utils/featureToggles'

import '../Clients.scss'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const clientsColumns: GridColumn[] = [
  {
    title: 'Full Name',
    field: ClientDtoKey.name,
    show: true,
    filter: 'text',
    cell: (props: GridCellProps) => (
      <td data-test='name-column'>
        <Link
          to={{
            pathname: generatePath(links.recordsClients.detailsUrl as string, {
              id: props.dataItem.id,
              slug: 'details',
            }),
          }}
        >
          {props.dataItem.name}
        </Link>
      </td>
    ),
  },
  {
    title: 'Client Type',
    field: ClientDtoKey.type,
    show: true,
    className: 'clients-table-columns__content',
    filter: 'text',
  },
  {
    title: 'Status',
    field: ClientDtoKey.status,
    show: true,
    className: 'clients-table-columns__content',
    filter: 'text',
  },
  {
    title: 'Country',
    field: ClientDtoKey.country,
    show: true,
    className: 'clients-table-columns__content',
    filter: 'text',
  },
  {
    title: 'Email address',
    field: ClientDtoKey.emailAddress,
    show: true,
    className: 'clients-table-columns__content',
    filter: 'text',
  },
  {
    title: 'Main IB',
    field: ClientDtoKey.introducingBroker,
    show: true,
    cell: (props: GridCellProps): JSX.Element => {
      const introducingBroker: NameDto | undefined = props.dataItem.introducingBroker
      if (!introducingBroker) {
        return <td />
      }
      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }} data-test='main-ib'>
          <Link
            to={{
              pathname: generatePath(links.recordsIntroducingBrokers.detailsUrl as string, {
                id: introducingBroker.id,
                slug: 'details',
              }),
            }}
          >
            {introducingBroker.name}
          </Link>
        </td>
      )
    },
  },
  {
    title: 'Phone Number',
    field: ClientDtoKey.phone,
    show: true,
    className: 'clients-table-columns__number',
    filter: 'text',
  },
  {
    title: 'Birthday',
    field: ClientDtoKey.birthday,
    show: true,
    filter: 'text',
    cell: (props: GridCellProps) => (
      <td className='clients-table-columns__date'>
        {formatLocalDateUTC(props.dataItem.birthday, false)}
      </td>
    ),
  },
  {
    title: 'Swap Free',
    show: true,
    cell: (props: GridCellProps): JSX.Element => {
      return (
        <td className='table-columns__date'>
          <input type='checkbox' checked={props.dataItem.isSwapFreeAccount} readOnly />
        </td>
      )
    },
    className: 'clients-table-columns__date',
    filter: 'text',
  },
  {
    title: 'Assignee',
    field: ClientDtoKey.assignee,
    show: true,
    className: 'clients-table-columns__content',
    filter: 'text',
  },
  {
    title: 'Entity',
    field: ClientDtoKey.tickmillCompany,
    show: true,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.tickmillCompany?.id) {
        return <td />
      }

      return (
        <td>
          <CompanyTag id={props.dataItem.tickmillCompany.id}>
            {props.dataItem.tickmillCompany.name}
          </CompanyTag>
        </td>
      )
    },
    filter: 'text',
    width: 80,
    minResizableWidth: 80,
  },
  {
    title: 'Date Created',
    field: ClientDtoKey.createdDate,
    show: true,
    cell: (props: GridCellProps) => (
      <td className='transaction-columns__date'>
        {formatLocalDateUTC(props.dataItem.createdDate, true)}
      </td>
    ),
    filter: 'text',
  },
]
